import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Unsubscribable } from 'rxjs';
import { Utility } from 'app/_service/utility';
import { UserService } from 'app/_service/user/user.service';
import { StorageService } from 'app/storageprovider';
import { StickyChatService } from './sticky-chat.service';
import { SocketFacade } from '../socket/socket.facade';

@Component({
  selector: 'app-sticky-chat',
  templateUrl: './sticky-chat.component.html',
  styleUrls: ['./sticky-chat.component.scss']
})
export class StickyChatComponent implements OnInit, OnDestroy {
  stickyBg: string;
  isDark = false;
  private subscription: Array<Unsubscribable> = [];
  user;
  partner;
  showChatLog = false; // should communicate with service
  showSticky = false; // should communicate with service
  @Input() innerPlayer = false;
  unreadNotificationMsgs = 0;
  unreadSocketMsgs = 0;

  messageSound = 'assets/sound/message.mp3';
  audio: any;
  lastSocketUnread = 0;
  constructor(
    private _userService: UserService,
    private _storage: StorageService,
    private _stickyChatService: StickyChatService,
    private socketFacade: SocketFacade,
    private _utility:Utility
  ) {
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"]);
    this.audio = new Audio();
  }

  ngOnInit(): void {
    this.subscription.push(
      this._userService.userState$.subscribe(p=>{
        this.user = p;
      }),
      this._userService.notificationState$.subscribe(p=> {
        // console.log(p);
        this.unreadNotificationMsgs = p.pm;
        if (p.pm > 0) {
          this.showSticky = true;
          this._stickyChatService.updateState(this.showSticky);
        }
      }),
      this.socketFacade.concatsHasUnreadMessage$.subscribe(r => {
        // console.log(r);
        // this.unreadSocketMsgs = r.length;
        this.unreadSocketMsgs = r.filter(s => s.isRemind === 1).length; // 只取强提醒
        if (this.unreadSocketMsgs === 0) {
          this.lastSocketUnread = 0;
        }
        if (this.unreadSocketMsgs > 0) {
          // this.partner = {
          //   id: r[0].id,
          //   name: r[0].name,
          //   avatar: r[0].avatar,
          //   entry: true
          // };
          if (this.lastSocketUnread !== this.unreadSocketMsgs) { // 防止打开后重复提示音
            this.playAudio(); // 播放socket消息提示音
            this.lastSocketUnread = this.unreadSocketMsgs;
            // 官方号收到新消息 或 用户收到官方号新消息，直接打开弹窗聊天消息
            if ((this.user.isOfficalSpeaker || r[0].isOfficalSpeaker) && !this.showChatLog) {
              this.toggleStickyChatLog();
            }
          }
          this.showSticky = true;
          this._stickyChatService.updateState(this.showSticky);
        }
      }),
      this._stickyChatService.showSticky.subscribe(state => {
        if (state !== undefined) {
          this.showSticky = state;
        };
      }),
      this._stickyChatService.showLog.subscribe(show => {
        if (show !== undefined) {
          this.showChatLog = show;
        };
      }),
      this._stickyChatService.partnerPkg.subscribe(p => {
        if (p !== undefined) {
          this.partner = {
            ...p,
            avatar: decodeURIComponent(p.avatar),
            name: decodeURIComponent(p.name),
          };
        };
      }),
      this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
        if (theme === 'dark') {
          this.isDark = true;
        }
        else {
          this.isDark = false;
        }
        // 切换颜色后
        this.stickyBg = `./assets/images/sticky-chat/sticky_bg${this.isDark ? '.png?v=4' : '_light.png?v=4'}`;
      }),
    );

    this.stickyBg = `./assets/images/sticky-chat/sticky_bg${this.isDark ? '.png?v=4' : '_light.png?v=4'}`;
  }

  ngOnDestroy(): void {
    this.subscription.forEach(p => p.unsubscribe());
  }

  toggleStickyChatLog() {
    this.showChatLog = !this.showChatLog;
    this._stickyChatService.toggleChatLog(this.showChatLog);
    if (this.showChatLog === false) {
      setTimeout(() => {
        this.partner = undefined;
      }, 100);
    }
  }

  onCloseChatLog() {
    this.showChatLog = false;
    this._stickyChatService.toggleChatLog(this.showChatLog);
  }

  closeSticky(e) {
    e.preventDefault();
    e.stopPropagation();
    this.showSticky = false;
    this._stickyChatService.updateState(this.showSticky);
    this.lastSocketUnread = 0; // 关闭悬浮后重置
    this.onCloseChatLog();
  }

  playAudio() {
    this.audio.src = this.messageSound;
    this.audio.load();
    this.audio.play();
    console.log('msg received sound played');
  }

}
